<ol class="progressbar">
  <ng-container *ngFor="let step of orderedList">
    <li
      [ngClass]="{ active: step.isActive }"
      [className]="className"
      [tooltip]="step.tooltip"
    >
      <span class="step" [ngClass]="step.class">
        <span *ngIf="step.showTick" class="check">✓</span>
      </span>
      <span class="text">{{ step.text | uppercase }}</span>
      <span
        *ngIf="!step.isLast"
        class="line"
        [ngClass]="{ dashed: step.isLastActive }"
      ></span>
    </li>
  </ng-container>
</ol>
